<template>
    <p hidden v-html="JSON.stringify(message)"></p>
</template>
<script>
import Swal from 'sweetalert2'
export default {
    props: {
        message: Object,
        toast: {
            type: Boolean,
            default: false,
        },
    },
    mounted () {
        if (this.toast) {
            const Toast = Swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener('mouseenter', Swal.stopTimer);
                    toast.addEventListener('mouseleave', Swal.resumeTimer);
                },
            });
            Toast.fire(this.message);
            return;
        }
        Swal.fire(this.message);
    },
}
</script>